import { render, staticRenderFns } from "./SyncIcon.vue?vue&type=template&id=64c7a2e1&"
import script from "./SyncIcon.vue?vue&type=script&lang=ts&"
export * from "./SyncIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports